import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { baseURL } from "services/API";
import { setReportsCacheLoading, setReportsCache, setReportsCacheError } from "state";

/**
 * Fetches comprehensive reports (all landlords) in the background after login
 * and stores in Redux so the Reports page can use cache and avoid a heavy API call.
 * Renders nothing.
 */
export function ReportsCacheFetcher() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const reportsCache = useSelector((state) => state.reportsCache);
  const { hasFetched, isLoading } = reportsCache ?? {};

  useEffect(() => {
    if (!token || hasFetched || isLoading) return;

    dispatch(setReportsCacheLoading(true));
    axios
      .get(`${baseURL}/admin/reports/comprehensive`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const reportData = response.data?.data?.report_data ?? [];
        const summary = response.data?.data?.summary ?? null;
        dispatch(setReportsCache({ reportData, summary }));
      })
      .catch(() => {
        dispatch(setReportsCacheError());
      });
  }, [token, hasFetched, isLoading, dispatch]);

  return null;
}
